import React from "react";
import HttpService from '../utils/Http.services';
import { siteConfig, siteTheme } from "../variables/config";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import { nanoid } from "nanoid";

import TLink from "../components/TLink";
// import RandomBack from "../components/RandomBack";
import StagesManager from "../components/StagesManager";
import LoginFirstStep from "./login/LoginFirstStep";
// import LoginCodeStep from "./login/LoginCodeStep";
// import LoginPasswordStep from "./login/LoginPasswordStep";
// import LoginInfoStep from "./login/LoginInfoStep";
// import LoginWelcomeStep from "./login/LoginWelcomeStep";
import { checkPermission, chooseWallpaper, getToken, pathMaker, translate } from "../utils/useful";
import Configurer from '../components/Configurer'
import { addTopic, socket } from "../utils/socket.services";
import HttpServices from "../utils/Http.services";
import store from "../stores/storeConfig";

class LoginWithUsername extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // colors: ['d7e2f7', 'eee1ff', 'fedfe7', 'dad6e4', 'f7dbd7', 'fff2e1'],
      loginInfo: {},
      stage: 0,
      canResend: true,
      errors: [],
      data: {},
      phone: '',
      settings: { indicatorType: 'phone', mode: 'login', loginWithCode: false, passwordRequired: true },
      ticketingId: nanoid()
    }
  }


  componentDidMount() {

    // this.changeStage('init')
    if (this.props.user.loggedin) {
      // this.props.history.push(pathMaker('/profile'))
    } else {
      let settings = this.state.settings
      let pathname = this.props.location.pathname.split('/')
      pathname = pathname[pathname.length - 1]
      if (pathname.toLowerCase() === 'forgotpassword') {
        settings.mode = 'forgotPassword'
      }

    }
  }

  goToInitPage = () => {
    this.changeStage('init')
  }

  componentDidUpdate(prevProps) {
    if (this.props.user != prevProps.user) {
      setTimeout(() => {
        // this.checkLogin()
      }, 4000);
    }
  }


  checkLogin() {
    if (this.props.user.loggedin) {
      // this.setState({})
      if (getToken()) {
        this.props.history.push(pathMaker('/me'))
      }
    }

  }


  postUserIndicator = (cb) => {
    let data = this.state.data

    // console.log(data)
    // if (data.userIndicator && data.userIndicator.length >= 5) {
    HttpService.request("employeeSignin", data, (fetchResult, fetchError, fetchStatus) => {
      // console.log(fetchError)

      if (fetchError) { if (cb) { cb(null, fetchError.message) }; return }

      if (fetchResult.token) {
        fetchResult.auth = { token: fetchResult.token }

        // console.log(fetchResult)

        this.loginDone(fetchResult)
      }

      // this.setData({ exist: fetchResult.exist })
      // if (fetchResult.exist && !this.state.settings.loginWithCode) {
      //   this.changeStage('password')
      // } else {
      //   this.changeStage('code')
      // }
      // if (cb) { cb() }
      //   })
      // } else {
      //   if (this.state.settings.indicatorType === 'phone') {
      //     cb(null, { userIndicator: "{{lang}}errors.phoneLength" })
      //   }
      //   if (this.state.settings.indicatorType === 'email') {
      //     cb(null, { userIndicator: "{{lang}}errors.emailPattern" })
    })
    // }
  }

  postForgotPassword = (cb) => {
    let data = this.state.data
    if (data.userIndicator && data.userIndicator.length >= 4) {
      HttpService.request("postForgotPassword", data, (fetchResult, fetchError) => {
        //  console.log(fetchResult)
        if (fetchError) { if (cb) { cb(null, fetchError.message) }; return }
        this.changeStage('code')
        if (cb) { cb() }
      })
    } else {
      if (this.state.settings.indicatorType === 'phone') {
        cb(null, { userIndicator: "{{lang}}errors.phoneLength" })
      }
      if (this.state.settings.indicatorType === 'email') {
        cb(null, { userIndicator: "{{lang}}errors.emailPattern" })
      }
    }
  }


  // postActicationCode = (cb) => {

  //   let data = this.state.data
  //   if (data.userIndicator && data.userIndicator.length >= 0 && data.code && String(data.code).length >= 4) {
  //     HttpService.request((this.state.data.exist || this.state.settings.mode === "forgotPassword") ? "signinActicationCode" : 'signupActicationCode', data, (fetchResult, fetchError) => {
  //       if (fetchError) { if (cb) { cb(null, fetchError.message) }; return }
  //       if (this.state.data.exist || this.state.settings.mode === "forgotPassword") {
  //         if (this.state.settings.passwordRequired || this.state.settings.mode === "forgotPassword") {
  //           this.changeStage('password')
  //         } else {
  //           // LOGIN
  //           this.loginDone(fetchResult)
  //         }
  //       } else {
  //         this.changeStage('info')
  //       }
  //       if (cb) { cb() }
  //     })
  //   } else {
  //     cb(null, { code: "{{lang}}errors.codeLength" })
  //   }
  // }


  // postPassword = (cb) => {

  //   let data = this.state.data
  //   if (data.userIndicator && data.userIndicator.length >= 0) {
  //     HttpService.request(this.state.settings.mode === 'forgotPassword' ? "postNewPassword" : 'postPassword', data, (fetchResult, fetchError) => {
  //       if (fetchError) { if (cb) { cb(null, fetchError.message) }; return }
  //       this.loginDone(fetchResult)
  //       if (cb) { cb() }
  //     })
  //   } else {
  //     cb(null, { code: "{{lang}}errors.codeLength" })
  //   }
  // }


  postUserInfo = (cb) => {
    let data = this.state.data
    if (data.userIndicator && data.userIndicator.length >= 0 && data.code && String(data.code).length >= 4) {
      HttpService.request("postUserInfo", data, (fetchResult, fetchError) => {
        if (fetchError) { if (cb) { cb(null, fetchError.message) }; return }
        this.loginDone(fetchResult)
        if (cb) { cb() }
      })
    } else {
      cb(null, { code: "{{lang}}errors.codeLength" })
    }
  }


  // loginDone = (data) => {
  //   this.setData(data.payload)
  //   if (data.payload?.access_token) {
  //     this.props.actions.setUser(data.payload, {token:data.payload.access_token}, true)
  //     // this.changeStage('welcome')
  //     this.props.history.push('/')
  //   }
  // }
  subscribeTicketing = (count, cb) => {
    console.log('subscribeTicketing', count)
    if (count <= 10) {

      setTimeout(() => {
        if (this.props.user?.info?.permissions) {
          // console.log('this.props.user?.info?.permissionsobject', this.props.user?.info?.permissions)
          if (checkPermission('trading.ticketing')) {
            // if(socket.)
            console.log('has admin.ticketing')
            addTopic(this.state.ticketingId, 'ticketing', 'admin', null, this.updateData)
          }
        }
        else {
          let ncount = count + 1
          this.subscribeTicketing(ncount, cb)
        }
      }, 40);
    }

  }
  updateData = () => {

  }
  loginDone = (data) => {
    console.log('onlogindone')
    console.log('data.auth?.token',data.auth?.token)
    this.setData(data.user)
    // console.log(data)
    if (data.auth?.token) {
      this.props.actions.setUser(data.user, data.auth, true)
      this.subscribeTicketing(0, () => {

      })
      this.syncData()
      this.props.history.push('/')
      // this.changeStage('welcome')
    }
  }
  syncData = () => {
    console.log('syncData0')
    HttpServices.request('getTicketsCount', {}, (fetchResult, fetchError) => {
      console.log('syncData0',fetchError)
      if (fetchError) {
        return
      }
      console.log('fetchResuktic', fetchResult.count)
      store.dispatch(actions.addTicketsCount(fetchResult.count))
    })

  }

  // loginDone = (data) => {
  //   // this.setData(data.user)
  //   this.setData(data.user)

  //   // console.log(data)
  //   if (data.auth?.token) {
  //     this.props.actions.setUser(data.user, data.auth, true)
  //     this.changeStage('welcome')
  //   }
  // }


  setData = (data, cb) => {
    let newData = this.state.data
    for (const [key, value] of Object.entries(data)) {
      newData[key] = value
    }
    this.setState({ data: newData }, () => {
      if (cb) { cb() }
    })
  }



  changeStage = (newStage, cb) => {
    if (this.stageManager) {
      this.stageManager.changeStage(newStage, cb)
    }
  }

  lastStage = () => {
    if (this.stageManager) {
      this.stageManager.lastStage()
    }
  }



  render() {
    return (

      <Configurer
        settingsInfo={{ showFooter: false, showTabBar: false, showHeader: false, headerTitle: '' }}
        title={"Login"}
        description={"Login"}
      >

        <section className="d-flex w-100 position-relative" style={{ minHeight: '100vh', padding: '0px', backgroundImage: "url(" + '/images/login-back.jpg' + ")", backgroundPosition: 'center', backgroundSize: 'cover' }}>

          <section className="row w-100 m-0 ">

            {/* <section className="d-none d-md-block col-12 col-md-5 col-lg-4" style={{ height: '100vh', position: 'sticky', top: 0, padding: '100px 30px 20px 30px', textAlign: 'center', backgroundImage: "url(" + 'https://cdn.hipwallpaper.com/i/76/47/utep5b.jpg' + ")", backgroundPosition: 'center', backgroundSize: 'cover' }}>
              <div className="h-100 w-100" style={{ background: '#00000050', position: 'absolute', top: 0, left: 0 }}></div>
              <div style={{ position: 'relative' }}>
                <img className="invert mb-2" src={siteTheme.logo} width={'90px'} />
                <h1 className="text-ultra-big white">{siteConfig.siteName}</h1>
                <h1 className="text-big white mt-2" style={{ whiteSpace: 'nowrap' }}>{translate('Signin-Signup')}</h1>
                <p className="white opacity-7" style={{ cursor: 'pointer', fontSize: 15, marginTop: 10, }}>{translate('cookie-warning')}</p>
              </div>
            </section> */}

            <section className="col-12  pb-5 flexcc" style={{ opacity: this.state.mainOpacity, transition: 'all 0.5s', flex: '1 1 auto', paddingTop: 100 }}>
              <div className="" style={{ backdropFilter: 'blur(50px)', WebkitBackdropFilter: 'blur(50px)', backgroundColor: '#ffffffaa', borderRadius: 25, padding: '30px 40px', boxShadow: '0px 0px 100px #000000aa' }}>
                <StagesManager ref={el => this.stageManager = el} >
                  <LoginFirstStep initData={this.state.data} setData={this.setData} settings={this.state.settings} postUserIndicator={this.state.settings.mode == "forgotPassword" ? this.postForgotPassword : this.postUserIndicator} stage={0} stageName={'init'} info={this.state.loginInfo} type={'phone'} />
                  {/* <LoginCodeStep initData={this.state.data} setData={this.setData} postUserIndicator={this.postUserIndicator} postActicationCode={this.postActicationCode} stage={1} stageName={'code'} />
                  <LoginPasswordStep initData={this.state.data} setData={this.setData} postPassword={this.postPassword} stage={2} stageName={'password'} />
                  <LoginInfoStep initData={this.state.data} setData={this.setData} postUserInfo={this.postUserInfo} stage={3} stageName={'info'} />
                  <LoginWelcomeStep initData={this.state.data} settings={this.state.settings} goToInitPage={this.goToInitPage} stage={4} stageName={'welcome'} /> */}
                </StagesManager>
              </div>
            </section>
          </section>
        </section>

      </Configurer>

    )
  }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginWithUsername);
